var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenueReconciliationIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512pt",
    height: "512pt",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#00205cff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    opacity: 1,
    d: " M 368.03 95.92 C 367.91 87.82 374.88 80.43 382.98 80.12 C 388.04 79.65 392.87 82.11 396.30 85.70 C 427.81 117.19 459.32 148.69 490.80 180.21 C 494.97 184.15 497.02 190.23 495.56 195.85 C 494.34 201.40 489.62 205.00 485.87 208.87 C 455.87 238.86 425.87 268.87 395.87 298.87 C 392.32 302.55 387.11 304.57 382.00 303.90 C 374.21 303.13 367.86 295.89 368.02 288.08 C 367.94 272.06 368.05 256.03 367.99 240.01 C 319.97 239.97 271.94 240.04 223.92 239.98 C 215.85 240.13 208.37 233.17 208.08 225.07 C 207.91 203.36 208.02 181.64 208.02 159.93 C 207.81 151.42 215.41 143.81 223.92 144.02 C 271.94 143.96 319.97 144.03 367.99 143.99 C 368.05 127.96 367.94 111.94 368.03 95.92 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    opacity: 1,
    d: " M 115.63 213.63 C 119.04 209.97 123.95 207.58 129.04 208.08 C 137.09 208.51 144.09 215.81 143.96 223.92 C 144.08 239.94 143.94 255.96 144.01 271.99 C 192.03 272.03 240.06 271.96 288.08 272.02 C 295.51 271.88 302.41 277.71 303.70 284.98 C 304.12 287.63 304.01 290.33 304.02 293.00 C 303.95 312.69 304.05 332.39 303.98 352.08 C 304.14 359.80 297.75 366.99 290.10 367.83 C 286.41 368.18 282.70 367.96 279.00 368.00 C 234.01 368.01 189.01 367.99 144.02 368.01 C 143.94 384.03 144.08 400.06 143.96 416.08 C 144.08 424.21 137.04 431.47 129.01 431.97 C 124.22 432.30 119.44 430.31 116.14 426.87 C 84.33 395.00 52.45 363.21 20.65 331.34 C 14.51 325.40 14.50 314.60 20.65 308.66 C 52.28 276.95 84.00 245.34 115.63 213.63 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueReconciliationIconW);
export default __webpack_public_path__ + "static/media/revenue-reconciliation-icon-w.33b296360b63238aa31cf732f24b9d8e.svg";
export { ForwardRef as ReactComponent };